import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "THIS IS NOT A GAME!", -1 /* HOISTED */)
const _hoisted_2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 512",
  style: {"fill":"#606569","margin-left":"25px","margin-right":"25px"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 9.8c0 39-23.7 74-59.9 88.4C71.6 154.5 32 213 32 278.2V352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-73.8c0-10 1.6-19.8 4.5-29L261.1 497.4c9.6 14.8 29.4 19.1 44.3 9.5s19.1-29.4 9.5-44.3L222.6 320H224l80 0 38.4 51.2c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8l-43.2-57.6C341.3 263.1 327.1 256 312 256l-71.5 0-56.8-80.2-.2-.3c44.7-29 72.5-79 72.5-133.6l0-9.8zM96 80A48 48 0 1 0 0 80a48 48 0 1 0 96 0zM464 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 78.7-12.2c6.5-1 11.7-5.9 13.1-12.2s-1.1-13-6.5-16.7l-65.6-45.1L603 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L508.3 92.1l-29.4-74C476.4 12 470.6 8 464 8s-12.4 4-14.9 10.1l-29.4 74L343.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1-65.6 45.1c-5.4 3.7-8 10.3-6.5 16.7c.1 .3 .1 .6 .2 .8l19.4 0c20.1 0 39.2 7.5 53.8 20.8l18.4 2.9L383 265.3l36.2 48.3c2.1 2.8 3.9 5.7 5.5 8.6L464 286.1z" }, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", null, "OR IS IT?!", -1 /* HOISTED */)

import { onMounted, ref, watch } from "vue";
import defineDebugState from "@src/composables/defineDebugState";
import gameModes from "@src/config/gameModes";
import defineDeviceState from "@src/composables/defineDeviceState";
import { de } from "vuetify/locale";


export default /*#__PURE__*/_defineComponent({
  __name: 'AboutModal',
  emits: ["close", "select"],
  setup(__props, { emit }) {

const deviceState = defineDeviceState();
const debugState = defineDebugState();
const packageVersion = require("/package.json").version;


const isModalVisible = ref(true);
const selectedMode = ref<string>("");

watch(
  () => isModalVisible.value,
  (val) => {
    if (!val) {
      close();
      isModalVisible.value = true;
    }
  },
);

watch(selectedMode, (val: string) => {
  const item = gameModes.find((element) => element.title === val);
  if (item) {
    deviceState.difficultyLevel.value = item.difficulty;
  }
});

function close(): void {
  emit("close");
}

onMounted(() => {
  const item = gameModes.find(
    (element) => element.difficulty === deviceState.difficultyLevel.value,
  );
  if (item) {
    selectedMode.value = item.title;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_VSelect = _resolveComponent("VSelect")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: isModalVisible.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isModalVisible).value = $event)),
    width: "auto"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, {
            align: "center",
            style: {"color":"#606569"}
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_card_text, {
            align: "center",
            onClick: close
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4))
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_card_text, {
            align: "center",
            style: {"color":"#606569"}
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_card_text, { align: "center" }, {
            default: _withCtx(() => [
              _createTextVNode("BMB v" + _toDisplayString(_unref(packageVersion)), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_card_text, { align: "center" }, {
            default: _withCtx(() => [
              _createVNode(_component_VSelect, {
                modelValue: selectedMode.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedMode).value = $event)),
                class: "ma-3",
                label: "Difficulty level",
                variant: "outlined",
                density: "compact",
                items: _unref(gameModes),
                disabled: _unref(deviceState).isDeviceArmed.value
              }, null, 8 /* PROPS */, ["modelValue", "items", "disabled"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_card_text, { align: "center" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_switch, {
                modelValue: _unref(debugState).isDebugModeEnabled.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(debugState).isDebugModeEnabled.value) = $event)),
                "hide-details": "",
                label: "Enable cheats"
              }, null, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          }),
          _createCommentVNode("      <v-card-actions>"),
          _createCommentVNode("        <v-btn color=\"secondary\" @click=\"close\">Close</v-btn>"),
          _createCommentVNode("      </v-card-actions>")
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue"]))
}
}

})